import { useMutation } from 'react-query'
import { useLocation } from 'react-router'
import { toast } from 'react-toastify'
import { postGatewayPayment } from 'services/easyPay'

export default function useSetGatewayPayment() {
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IGatewayPaymentPayload) => {
            return postGatewayPayment(payload)
        },
        onSuccess: (result, variables) => {
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({
                    type: 'group-all-payment',
                    data: state.toBePaidTransactions,
                    //@ts-ignore
                    pk: result?.pk,
                    //@ts-ignore
                    gateway: result?.gateway,
                })
            )
            //@ts-ignore
            window.location.replace(result?.payment_link)
            console.log('result : ', result)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate, isLoading }
}
